import {React, useEffect, useState} from 'react';
import Popup from './Popup';
import Dropdown2 from './Dropdown2';
import Button from './Button';
import EditText from './EditText';
import API_URLS from '../Urls';
import EditPassword from './EditPassword';
// Componente para ver los datos de un usuario
const ViewUser = ({user_id, onClose}) =>{
const [user,setUser] = useState()
const [editPassword,setEditPassword] = useState(false)
  const [newUserData,setNewUserData] = useState()
  const [userData,setUserData] = useState({})
  const fetchData = (url,onSuccesful) => {
        console.log(url)
        fetch(url, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
            
        })
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
            return response.json();
        })
        .then(data => {    
          console.log(data)
            if (typeof onSuccesful === 'function') onSuccesful(data[0]);
            
        })
        .catch(error => console.error('There was a problem with the fetch operation:', error));
    }
    
  const [selectedAccess, setSelectedAccess] = useState({});
  const [editingEnabled,setEditingEnabled] = useState(false)
  // Función para obtener los datos del usuario
  const fetchUserData = (id) =>{
    fetchData(API_URLS.GET_USER + '?id='+id,data=>{
      setUser(data);
      setNewUserData(data);
      setUserData({
        email:data.email,
        nombre:data.nombre,
        telefono:data.telefono,
        usuario:data.usuario
      })

      // Función para obtener los accesos del usuario
      setSelectedAccess({
  acceso_cotizaciones: data.acceso_cotizaciones,
  acceso_notas_recepcion: data.acceso_notas_recepcion,
  acceso_inventario: data.acceso_inventario,
  acceso_catalogo: data.acceso_catalogo,
  acceso_usuarios: data.acceso_usuarios,
  acceso_clientes: data.acceso_clientes,
  acceso_proceso: data.acceso_proceso  // ✅ Add this line
});


    })
  }
  useEffect(() => {
    console.log(user_id)
    fetchUserData(user_id)
  }, [user_id])

  // Función para actualizar los datos del usuario
  const putData = (url, dataToSend, onSuccesful) => {
        console.log("Posting to URL:", url); // Check URL during each post
        console.log("Data to send:", dataToSend);

        fetch(url, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataToSend)
        })
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
            return response.json();
        })
        .then(data => {
          console.log(data);
            if (typeof onSuccesful === 'function') onSuccesful(data);
            
        })
        .catch(error => console.error('There was a problem with the fetch operation:', error));
    };
  
  return (
    // Popup para editar el usuario
    <Popup title={`Ver usuario: ${user?.usuario ?? "Desconocido"}`} onClose={()=>onClose()}>
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <div className='header1' style={{ marginBottom: '20px' }}>Información del usuario</div>
        {user ? (
          (() => {
            // Unimos los campos de userData y selectedAccess para mostrar en dos columnas
            const userFields = Object.keys(userData).map(field => ({ key: field, value: user[field], editable: true }));
            const accessFields = Object.keys(selectedAccess).map(field => ({ key: field, value: selectedAccess[field], editable: true, isAccess: true }));
            // Campo especial para is_active
            const activeField = { key: 'is_active', value: user.is_active, editable: true, isActive: true };
            // Todos los campos que no son acceso_ ni is_active a la izquierda
            const leftCol = [...userFields, activeField].filter(f => !f.key.startsWith('acceso_'));
            // Todos los accesos a la derecha
            const rightCol = accessFields;
            return (
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '40px', width: '100%' }}>
                {[leftCol, rightCol].map((col, colIdx) => (
                  <div key={colIdx} style={{ display: 'flex', flexDirection: 'column', alignItems: 'left', gap: '15px', flex: 1 }}>
                    {colIdx === 1 && (
                      <div style={{ fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'left' }}>Accesos</div>
                    )}
                    {col.map((fieldObj, index) => {
                      const { key, value, editable, isAccess, isActive } = fieldObj;
                      let label = key;
                      if (isAccess) label = key.replace("acceso_", "Acceso ");
                      if (isActive) label = "Usuario activo";
                      return (
                        <div key={index} style={{ display: 'flex', alignItems: 'left', justifyContent: 'left', gap: '10px', width: '100%' }}>
                          <span style={{ fontWeight: 'bold', minWidth: 'auto', textAlign: 'left' }}>{label}:</span>
                          {editingEnabled && editable ? (
                            isActive ? (
                              <Dropdown2
                                options={["FALSE","TRUE"]}
                                value={user.is_active.toString()}
                                returnSelectedOption={e => setNewUserData(prev => ({ ...prev, is_active: e === "TRUE" }))}
                                style={{ maxWidth: '250px', width: '250px' }}
                              />
                            ) : isAccess ? (
                              <Dropdown2
                                options={["NO ACCESS", "READ", "WRITE"]}
                                value={selectedAccess[key]}
                                returnSelectedOption={e => setSelectedAccess({ ...selectedAccess, [key]: e })}
                                style={{ maxWidth: '250px', width: '250px' }}
                              />
                            ) : (
                              <EditText
                                onChange={data => setNewUserData(prevData => ({ ...prevData, [key]: data }))}
                                defaultText={user[key]}
                                style={{ maxWidth: '250px', width: '250px' }}
                              />
                            )
                          ) : (
                            <div style={{ padding: '8px 12px', backgroundColor: '#f5f5f5', borderRadius: '4px', minWidth: '120px', maxWidth: '250px', textAlign: 'left' }}>
                              {isActive ? (user.is_active ? 'Sí' : 'No') : value}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                ))}
              </div>
            );
          })()
        ) : (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <div style={{ fontSize: '18px', color: '#666' }}>Cargando...</div>
          </div>
        )}
        <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center', gap: '15px' }}>
          <Button text="Cambiar contrasena" 
            onClick={()=>{setEditPassword(true)}}
          />
          {editPassword &&(
            <EditPassword onClose={()=>setEditPassword(false)} user={user} onAccept={(p)=>{
              putData(API_URLS.UPDATE_PASSWORD,{user_id:user.user_id,new_password:p},()=>{alert("Contraseña actualizada correctamente"); setEditPassword(false)})
            }}></EditPassword>
          )}
          { !editingEnabled ? (
            <Button text='Editar' onClick={()=>{setEditingEnabled(true)}} style={{ color: 'Black' }}></Button>
          ) : (
            <Button text='Guardar' onClick={() => {
              putData(API_URLS.UPDATE_USER, { ...newUserData, ...selectedAccess }, () => fetchUserData(user_id));
              setEditingEnabled(false);
            }} style={{ color: 'Black' }}></Button>
          )}
        </div>
      </div>
    </Popup>
  );
}
export default ViewUser;